import React from 'react';
import styled, { keyframes, css } from 'styled-components';

/* shimmer sweep animation */
const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position:  400px 0; }
`;

const shimmerBase = css`
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e8e8e8 37%,
    #f0f0f0 63%
  );
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s ease infinite;
`;

/* ---------- skeleton pieces ---------- */
const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(31, 45, 61, 0.07);
  box-shadow: 0 2px 8px rgba(31, 45, 61, 0.04);
`;

const ImgPlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 1 / 1;
  ${shimmerBase}
`;

const Body = styled.div`
  padding: 10px 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TitleBar = styled.div`
  height: 13px;
  border-radius: 6px;
  width: 78%;
  ${shimmerBase}
`;

const PriceBar = styled.div`
  height: 13px;
  border-radius: 6px;
  width: 42%;
  ${shimmerBase}
`;

/* ---------- grid skeleton (2 cols mobile → 4 cols desktop) ---------- */
const SkeletonGrid = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, 1fr);

  @media (min-width: 580px) { gap: 12px; }
  @media (min-width: 640px) { grid-template-columns: repeat(3, 1fr); }
  @media (min-width: 960px) { grid-template-columns: repeat(4, 1fr); }
  @media (min-width: 1280px) { grid-template-columns: repeat(5, 1fr); }
`;

/* ---------- market header skeleton ---------- */
const HeaderPlaceholder = styled.div`
  height: 60px;
  border-radius: 14px;
  margin-bottom: 16px;
  ${shimmerBase}
`;

const SectionPlaceholder = styled.div`
  max-width: 1180px;
  margin: 30px auto;
  padding: 0 16px;

  @media (min-width: 768px) { padding: 0 24px; }
`;

/* ------------------------------------------------------------------ */

/** Single shimmer product card */
export const SkeletonCard = () => (
  <Card>
    <ImgPlaceholder />
    <Body>
      <TitleBar />
      <PriceBar />
    </Body>
  </Card>
);

/** Full-page skeleton that mirrors the real GMarketAltList layout */
export const HomePageSkeleton = ({ sections = 2, cardsPerSection = 8 }) => (
  <>
    {Array.from({ length: sections }).map((_, si) => (
      <SectionPlaceholder key={si}>
        <HeaderPlaceholder />
        <SkeletonGrid>
          {Array.from({ length: cardsPerSection }).map((_, ci) => (
            <SkeletonCard key={ci} />
          ))}
        </SkeletonGrid>
      </SectionPlaceholder>
    ))}
  </>
);

export default SkeletonCard;
